import React from "react";
import { DonationCard } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Appeal = props => {
  var {
    children,
    theme,
    hero,
    header,
    content,
    identifier
  } = props;
  return /*#__PURE__*/_jsxs("section", {
    "data-theme": theme,
    children: [/*#__PURE__*/_jsx("header", {
      className: "bg-primary grid place-items-center min-h-[400px]",
      style: {
        background: hero && hero.filename ? "url(" + hero.filename + ")" : undefined,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat"
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "max-w-screen-xl mx-auto w-full p-8",
        children: header
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "mx-auto max-w-screen-xl p-16 grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-16",
      children: [/*#__PURE__*/_jsx("div", {
        className: "col-span-3",
        children: content
      }), /*#__PURE__*/_jsx("div", {
        className: "order-first lg:order-last col-span-2",
        children: /*#__PURE__*/_jsx(DonationCard, {
          identifier: identifier
        })
      })]
    })]
  });
};

var capitalise = str => str.charAt(0).toUpperCase() + str.slice(1);
//# sourceMappingURL=appeal.js.map